// Area config, kept as config so a new city is one line (docs/SPEC.md "What Nowish is").
/** St. Pete: where the map starts when the browser's location isn't available. */
export const FALLBACK_CENTER = { lat: 27.758, lng: -82.668 };
export const START_ZOOM = 12.3;
